import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']
  static classes = [ 'activeTab', 'activePanel' ]

  switch(event) {
    const targetTab = event.currentTarget

    let targetPanel
    if (event.params.index) {
      targetPanel = this.panelTargets[event.params.index]
    } else if (event.params.id) {
      targetPanel = this.panelTargets.find((panel) => panel.dataset.tabId == event.params.id)
    } else {
      const index = this.tabTargets.indexOf(targetTab)
      targetPanel = this.panelTargets[index]
    }

    if (!targetPanel) {
      return
    }

    const activeTabClass = this.hasActiveTabClass ? this.activeTabClass : 'is-active'
    this.tabTargets.forEach((tab) => {
      if (tab === targetTab) {
        tab.classList.add(activeTabClass)
      } else {
        tab.classList.remove(activeTabClass)
      }
    })

    const activePanelClass = this.hasActivePanelClass ? this.activePanelClass : 'is-show'
    this.panelTargets.forEach((panel) => {
      if (panel === targetPanel) {
        panel.classList.add(activePanelClass)
      } else {
        panel.classList.remove(activePanelClass)
      }
    })
  }
}
